import React, { Component,createRef } from "react";
import { connect } from 'react-redux';
import {FormBlocks} from '../FormBlocks';
import {formFieldsAttributes} from '../../../FormBuilderFunctions/FieldProps';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import {isSet,currencyListUtil,userUtilList,isEmptyValueExist,getSelectedValueBasedOnField,fileNameShortenForDisplay,parameterizedURLAccessToken} from '../../../../../Utils/CommonFunctions';
import { withRouter } from "react-router";
import $ from 'jquery';
import http from '../../../../../services/http';
import {getUserInfo,getUserAuthorities,getWindowIcons,getProfileAuthorities} from '../../../../../Utils/UserFunctions';
import SingleUserModal from '../UserField/SingleUserModal';
import MultiUserModel from '../UserField/MultiUserModel';
import LookupModal from '../Lookup/LookupModal';
import MultiLookupModal from '../MultiLookup/MultiLookupModal';
import WindowIcons from '../../../../../Components/Icons/WindowIcon';
import Icons from '../../../../../Components/Icons/Icons';
import { LOOKUP_API_FIELD_ID,API_STATUS_SUCCESS,USERS_WINDOW_ID,RATE_SHEET_WINDOW_ID,ORGANIZATION_WINDOW_ID,EMAIL_WINDOW_ID,PROFILE_WINDOW_ID,NOTES_WINDOW_ID,CUSTOM_WINDOW_ID,ADDITIONAL_LAYOUT_FIELDS } from '../../../../../Global/Constants';
import { getFieldPropertiesFromGridList } from '../../../../../Containers/LayoutContainer/LayoutCommonFunction';
import {
  loader,
} from '../../../../../store/actions/auth';
import {
  failMessage,
  succMessage
} from '../../../../../store/actions/CommonActions';


class CustomAllFiles extends Component {
	fileObj = [];
  	fileArray = [];  	
    constructor(props) {
	    super(props)
	    this.state = {
	      files: [],
	      totalSize:0,
	      maxSize:20,
	      getFiles:[],
	      componentName:this.props.item.element_original,

	    }
	    this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);
	    this.myUploadRef = createRef();
	    this.uploadFiles = this.uploadFiles.bind(this)
	}

	componentDidUpdate = (prevProps,prevState) => {    
	    const {item} = this.props
	    //console.log('componentDidUpdate item==',item)
	    if(prevProps.item!==this.props.item || prevProps.item.selectedValue!==this.props.item.selectedValue){
	      //console.log('yesss CustomAll',prevProps.item,this.props.item)
	      //console.log('componentDidUpdate==',item)
	      let getSelectedValue = '';
	      getSelectedValue = (isSet(item.selectedValue,null)!==null || item.overridden)?item.selectedValue:(isSet(item.default_value,null)!==null)?item.default_value:[];
	      this.setState({getFiles:getSelectedValue})
	    }
	}


	/*************** Existing Method******************/
	componentDidMount =()=>{
    	this.updateFilesSizes();
  	}

	updateFilesSizes = ()=>{
		const {getFiles} = this.state;
	    let updateFiles = getFiles;//this.props.item.files;
	    let totalSize = 0;
	    updateFiles.map((itemFile)=>{
	      const fileSize = itemFile.size;
	        totalSize = Number(fileSize)+Number(totalSize);
	    })
	    this.setState({totalSize:totalSize});
    }

    uploadFiles(e) {
        e.preventDefault()
        // console.log(this.state.file);
    }

	uploadMultipleFiles(e) {
        let updateFiles = this.state.files;
        this.uploadFileAPICall(e.target.files);
        updateFiles.push(e.target.files)
        this.setState({files:updateFiles}); 
    }

	onFileChange =()=>{
		const {getFiles} = this.state;
      if(this.props.item.modType==='LAYOUT'){
        return false;
      }else{
        if(this.props.item.is_avatar===true){
          // this.props.onChangeInputAction({
          //   section_index:this.props.section.section_index,
          //   itemIndex:this.props.item.itemIndex,
          //   item:this.props.item,
          //   ...this.props.subformObj
          // },[],'Files');
        }else{
          const totalFilesize = ((this.state.totalSize / (1024*1024)).toFixed(2));
          console.log(totalFilesize);
          //if(Number(totalFilesize)>Number(this.props.item.max)){
          if(Number(totalFilesize)>this.state.maxSize){
            this.props.failMessage('Image maximum size exceeded.');
            return false;
          }else if(getFiles.length>this.props.item.max){
            this.props.failMessage('Maximum '+this.props.item.max+' files only allowed.');
            return false;
          }  
            var inputField = this.refs.uploadMultipleFiles;
            inputField.click();
        }
      }                  
    } 

    uploadFileAPICall = async (files)=>{
    	const {getFiles} = this.state;
    	//console.log('getFiles==',this.state)
      let totalFileLength = getFiles.length+files.length;
      let totalFilesize = 0;

      if(this.props.item.element_original === 'ImageUpload'){
      	if(this.props.item.is_avatar===true){

	      }else if(totalFileLength>Number(this.props.item.max)){
	        this.props.failMessage('You can upload a maximum of '+this.props.item.max+' images only.');
	        return false;
	      }

	      if(Object.entries(files).length===0){
	        return false;
	      }

	      Object.entries(files).map(([key, fileItem]) => {
	        const totalFilesize1 = ((fileItem.size / (1024*1024)).toFixed(2));
	        totalFilesize += parseFloat(totalFilesize1);
	      })

	      if(getFiles) {
	        getFiles.map(fileItem => {
	          const totalFilesize1 = ((fileItem.size / (1024*1024)).toFixed(2));
	          totalFilesize += parseFloat(totalFilesize1);
	        })
	      }

	      if(totalFilesize > this.state.maxSize) {
	        this.props.failMessage('Image maximum size exceeded.');
	        return false;  
	      }
	      
	      if(this.props.item.is_avatar===true){
	        await this.props.onChangeInputAction(this.props.fieldObj,[],'Files');
	      }	
      }else{
      	if(totalFileLength>Number(this.props.item.max)){
	        this.props.failMessage('You can upload a maximum of '+this.props.item.max+' files only');
	        return false; 
	    } 
      }
      
      
      this.props.Loader(true);
      Object.entries(files).map(([key, fileItem]) => {
        const formData = new FormData();            
        formData.append("upload_file", fileItem);
        const APIURL = 'files/upload';
        http.POST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
        .then(res => {    
          this.props.Loader(false);
            if(res.status==200){                        
                const response = res.data;
              if(response.code===200){
                  const responseData =  response.data;
                  let filesArr = getFiles;
                  filesArr.push({
                    id:responseData,
                    value:responseData,
                    checked:null,
                    file:fileItem,
                    label:fileItem.name,
                    size:fileItem.size
                  });
                  this.props.onChangeInputAction(this.props.fieldObj,filesArr,'Files');
                  this.updateFilesSizes();
                }else{
                  this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
                }                                                
            }else{
                // this.props.Loader();
                this.props.failMessage('Something went wrong..');
            }
        })
        .catch(err => {
            console.log(err);
            this.props.Loader(false);
            this.props.failMessage('Something went wrong..');                    
        })
      })
  	}

  	removeAddedFile = (Fileindex)=>{
  		const {getFiles} = this.state;
      let updateFiles = getFiles;
      updateFiles = updateFiles.filter((item,index)=>{
        if(index!== Fileindex){
          return item;
        }
      })
      // this.setState({files:updateFiles});
      //console.log('updateFiles==',updateFiles)
      this.props.onChangeInputAction(this.props.fieldObj,updateFiles,'Files');
      
      setTimeout(() => {
        this.updateFilesSizes();
      }, 200);
    }

    /*************** Existing Method******************/

	render() {
		const  {
	      item,
	      className,
	      validationForms,
	      section,
	      fieldObj
	    } = this.props;
	    const attr = formFieldsAttributes(
	      {...item,className:className
	    },validationForms,e => this.props.onChangeInputAction(fieldObj,e));

	    const {getFiles,componentName} = this.state;

	    const filesLength = getFiles.length;
	    //console.log('item.filesitem.files',item);
	    //console.log('filesLength',filesLength,componentName);
	    const readOnlyVal = attr.fieldAttributes ? attr.fieldAttributes.readOnly : false;

		return(
			<Wrp>
				<div className="input-group position-static">
		 			<div className="customized-control">
						<div className="componenetInner text-truncate w-100">
							{
								componentName === 'ImageUpload'?
								<>
									{
										filesLength === 0?
										<span className="last_light_color mb-0 text-small"> No Images Added </span>
										:
										<div className="avatar-group">
											{
												getFiles.map((itemFile,index)=>{
													let imagePath = '/assets/img/noimage.png';
													if(itemFile.file && itemFile.file.type){
									                  imagePath = URL.createObjectURL(itemFile.file);
									                }else if(itemFile.id!==''){
									                  imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
									                }
													return(
														<div className="avatar-xs">
															<img src={imagePath} alt={imagePath} className="avatar-img rounded-circle border border-white" />
														</div>
													)	
												})
											}
										</div>
									}	
								</>
								:
								<>
									{
										filesLength === 0?
										<span className="last_light_color mb-0 text-small"> No Files Added </span>
										:
										<>
											{
												getFiles.map((itemFile,index)=>{
													let imagePath = '/assets/img/noimage.png';
													if(itemFile.file && itemFile.file.type){
									                  imagePath = URL.createObjectURL(itemFile.file);
									                }else if(itemFile.id!==''){
									                  imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
									                }
									                const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
													return(
														<span className="tagsInner badge badge-default">{itemFileLabel}</span>
													)	
												})
											}
											
										</>
									}	
								</>
							}
																 
						</div>
						<span className="custom-select cursor-pointer" data-toggle="dropdown" aria-expanded="false"></span>

						{
							filesLength===0?
							<div className="dropdown-menu dropdown-menu-right dropnotHide" style={{"width":"265px","padding-top":"0px","position":"absolute","transform":"translate3d(581px, 48px, 0px)","top":"0px","left":"0px","will-change":"transform"}} x-placement="top-end"> 		       		   		
			       		   		<div className="p-2 d-flex align-items-center justify-content-center text-center  text-wrap">
			       		   			{
			       		   				componentName === 'ImageUpload'?
			       		   				<div className="text-small op-6">
											<i className="fas fa-file-image fa-2x last_light_color"></i><br /> 
											Total size is limited to <b> 20 MB</b> or a maximum of <b className="proximas">{this.props.item.max}</b> images.
										</div>
			       		   				:
			       		   				<div className="text-small op-6">
											<i className="fas fa-file-alt fa-2x last_light_color"></i><br /> 
											Maximum <b className="proximas"> {this.props.item.max} </b> files are allowed.
										</div>
			       		   			}
									 
								</div>
							</div>
							:
							<div className="dropdown-menu dropdown-menu-right dropnotHide" style={{"width":"250px","padding-top":"0px"}}>
								<div className="card-body p-0 fixedHeight">
									<div className="card-list">
									{
										(filesLength>0)?
										<>
											{
												getFiles.map((itemFile,index)=>{
													let imagePath = '/assets/img/noimage.png';
													if(itemFile.file && itemFile.file.type){
									                  imagePath = URL.createObjectURL(itemFile.file);
									                }else if(itemFile.id!==''){
									                  imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
									                }

									                const ext = itemFile.label.split('.').pop();
							                      	let fileIcon = 'fas fa-file';
							                      	let roundedClass = '';
							                      	if(ext==='pdf'){
							                        	fileIcon = 'fas fa-file-pdf';
							                        	roundedClass = 'bg-danger';
							                      	}else if(ext==='doc' || ext==='docx'){
							                        	fileIcon = 'far fa-file-word';
							                        	roundedClass = 'bg-info';
							                      	}else if(ext==='xls' || ext==='xlsx'){
							                        	fileIcon = 'far fa-file-excel';
							                        	roundedClass = ' bg-success';
							                      	}else if ((itemFile.label).match(/.(jpg|jpeg|png|gif)$/i)){
							                        	fileIcon = 'fas fa-upload';
							                        	roundedClass = ' bg-success';
							                      	}       
									                const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
									                return(
									                	<div className="item-list">
									                		<div className="avatar avatar-sm ml-2">
									                			{
									                				componentName === 'ImageUpload'?
									                				<img src={imagePath} alt={imagePath} className="avatar-img rounded-circle border border-white" />
									                				:
									                				<span className={"avatar-title rounded-circle border border-white "+roundedClass}><i className={fileIcon}></i></span>
									                			}
															</div>
															<div className="info-user ml-2 w-50">
																<div className="username text-truncate mb-0">{itemFileLabel}</div> 
															</div>
															<a className="cursor-pointer pr-2" onClick={this.removeAddedFile.bind(this,index)}>
																<Icons iconType="Delete" size={16} color={'#000'}/>
															</a>	
									                	</div>
									                )
												})
											}
										</>
										:
										<div className="text-center">
											<i className="fas fa-file-image fa-2x last_light_color"></i>
								            <p className="last_light_color mb-0 text-small"> No Files added</p>
								        </div>
									}	
									</div>
								</div>	
							</div>
						}

						 						
					</div>

					<input 
		                type="file" 
		                accept={componentName==='ImageUpload'?"image/*":''} 
		                id="imageUploadButton" 
		                ref={'uploadMultipleFiles'} 
		                multiple={(item.max>1)?'multiple':''} 
		                disabled={readOnlyVal}
		                style={{display:'none'}} 
		                onChange={this.uploadMultipleFiles}
		            />
		            {
		            	readOnlyVal === false?
		            	<div className="input-group-append cursor-pointer" title="Upload Images" onClick={this.onFileChange}>
							<span className="input-group-text"> 							
								<i className="fas fa-upload secondary_color"></i>
							</span>
						</div>
		            	:
		            	<></>
		            }					
				</div>
			</Wrp>
		)
	}

}

CustomAllFiles.defaultProps = {
  generator: false,
  className: "form-control"
}


const mapDispatchToProps = dispatch => {
  return {
    Loader : (boll) => dispatch(loader(boll)),
    succMessage : (msg) => dispatch(succMessage(msg)),
    failMessage : (msg) => dispatch(failMessage(msg)),
  };
}
export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(CustomAllFiles));